import { QA_DATA } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import * as helper from "../../helpers/quetionanswer"
export const initialState = {
  currentBotSetting: 1,
  qaTableData: [] as any,
  searchqaTableData: [] as any,
  isEdit: false,
  currentEditData: [] as any,
  mapFlowData: [] as any,
  languageStatus: [],
  intentStatus: [],
  responseQAdata:[],
  currentQAadd : false,
  unRespondQueryIndex:0
};
const getAllQAList = createSlice({
  name: QA_DATA,
  initialState,
  reducers: {
    handleBotSettings: (state, { payload }) => {
      state.currentBotSetting = payload;
    },
    responseQAdata: (state, { payload }) => {
      state.responseQAdata = payload;
    },
    unRespondQueryIndex: (state, { payload }) => {
      state.unRespondQueryIndex = payload;
    },
    updateTableData: (state, { payload }) => {
      state.qaTableData = payload.qaTableData;
      state.searchqaTableData = payload.searchqaTableData;
    },
    handleEditStatus: (state, { payload }) => {
      state.isEdit = payload;
    },
    currentQAadd : (state, { payload }) => {
      state.currentQAadd = payload;
    },
    currentSelectedData: (state, { payload }) => {
      state.currentEditData = payload;
      if(payload.length === 0){
        state.mapFlowData = payload;
      }
    },
    saveMapFlowData : (state,{payload}) => {
      state.mapFlowData = payload
    },
    updateLanguageStatus : (state, {payload}) =>{
      state.languageStatus = payload;
      helper.doCommonSearch(state)
    },
    updateIntentStatus : (state, {payload}) =>{
      state.intentStatus = payload;
      helper.doCommonSearch(state)
    },
    reset: () => {},
  },
});
export const GetAllQAActions = getAllQAList.actions;
export default getAllQAList.reducer;